import { css } from "styled-components";

export const focusedFormControlStyle = `1px solid var(--dui-color-black-500)`;

export const focusedState = {
  noOutline: css`
    &:focus,
    &:active {
      outline: 2px solid transparent;
    }
  `,
  focusWithinBottomAndSides: css`
    &:focus-within {
      border-bottom: ${focusedFormControlStyle};

      &::after,
      &::before {
        border-color: var(--dui-color-black-500);
        border-width: var(--dui-size-width-border-sm);
      }

      &::after {
        bottom: -2px;
      }
    }
  `,
  focusAllBorders: css`
    &:focus {
      outline: 1px solid transparent;
      border-color: transparent;
      box-sizing: border-box;
      border: ${focusedFormControlStyle};
    }
  `,
  focusWithinAllBorders: css`
    &:focus-within {
      outline: 1px solid transparent;
      border-color: transparent;
      box-sizing: content-box;
      border: ${focusedFormControlStyle};
    }
  `,
  focus: css`
    &:focus,
    &:active {
      border: ${focusedFormControlStyle};
      outline: 1px solid tranparent;
    }
  `,
  outlineAllBorders: css`
    &:focus {
      outline: ${focusedFormControlStyle};
    }
  `,
  lightGray: css`
    &:focus,
    &:active {
      border: 0;
      outline: 2px solid var(--dui-color-gray-600);
    }
  `,
  transparentBorderAndFocus: css`
    border: var(--dui-size-width-border-sm) solid transparent;

    &:focus,
    &:active {
      border: ${focusedFormControlStyle};
      outline: 1px solid transparent;
    }
  `,
  radioCheckBoxFocus: css`
    &:focus,
    &:active {
      outline: 1px solid transparent;

      &::before {
        border: ${focusedFormControlStyle};
        outline: 1px solid transparent;
      }
    }
  `,
};
